import React from 'react';
import Accommodations from '../components/Accommodations';

const AccommodationsPage = () => {
  return (
    <>
      <Accommodations />
    </>
  );
};

export default AccommodationsPage;
